import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { NAV_ITEMS, isNavActive } from '@/shared/components/layout';
import { useT } from '@/shared/i18n/useT';

const PUBLIC_TITLES: Record<
  string,
  'nav.registro' | 'nav.recuperar' | 'nav.restablecer' | 'nav.verificar' | 'nav.entrar'
> = {
  '/cuenta/entrar': 'nav.entrar',
  '/cuenta/registro': 'nav.registro',
  '/cuenta/recuperar': 'nav.recuperar',
  '/cuenta/restablecer': 'nav.restablecer',
  '/cuenta/verificar': 'nav.verificar',
};

/** Título de la pestaña según la ruta: «Precios · Pizarra Agro». */
export function useRouteTitle(): string {
  const { t } = useT();
  const { pathname } = useLocation();
  const publicKey = PUBLIC_TITLES[pathname];
  const item = NAV_ITEMS.find((n) => isNavActive(pathname, n));
  const section = publicKey ? t(publicKey) : item ? t(item.label) : null;
  return section ? `${section} · ${t('appName')}` : `${t('appName')} — ${t('tagline')}`;
}

/**
 * Al cambiar de ruta: actualiza `document.title` y mueve el foco al contenedor principal (`#contenido`),
 * para que teclado y lectores de pantalla empiecen en la pantalla nueva. No actúa en el primer pintado.
 */
export function useRouteEffects(): void {
  const title = useRouteTitle();
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    document.getElementById('contenido')?.focus({ preventScroll: true });
    window.scrollTo({ top: 0 });
  }, [pathname]);
}
